import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class MemeberRecordApi extends BasicsClass {
    public apiUrls: any = new Map([
        ['getMemberOpenRecordTableList', {
            url: '/admin/member/record',
            name: 'list',
            label: '列表'
        }],
        ['getMemberTypeList', {
            url: '/admin/member/config',
            name: 'member-config',
            label: '会员配置',
            // hidden: true
        }],
        ['exportExcelMemberOpenList', {
            url: '/admin/member/export',
            name: 'export-excel',
            label: '导出'
        }],
        ['refundMemberOrderCharge', {
            url: '/admin/member/refund',
            name: 'refund-member',
            label: '退款会员'
        }]
    ])

    // 会员开通记录列表
    public getMemberOpenRecordTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getMemberOpenRecordTableList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // 会员配置
    public getMemberTypeList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getMemberTypeList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }


    // // 导出会员开通记录
    public exportExcelMemberOpenList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('exportExcelMemberOpenList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // // 导出会员开通记录
    public refundMemberOrderCharge(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('refundMemberOrderCharge').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }
}